export default "__VITE_ASSET__a599b127__"